import { render, staticRenderFns } from "./advKao.vue?vue&type=template&id=59af83f2&scoped=true"
import script from "./advKao.vue?vue&type=script&lang=js"
export * from "./advKao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af83f2",
  null
  
)

export default component.exports